
/* injects from baggage-loader */
require('./style.styl');

export {default} from './InCommingDataView'



// WEBPACK FOOTER //
// ./client/views/DataCollectionView/index.js